<template>
  <!-- <el-container>
    <aside-nav />
    <el-main>
      <router-view></router-view>
    </el-main>
    <el-footer>
      <web-footer />
    </el-footer>
  </el-container> -->
  <el-container>
    <!-- <el-aside> 
      <el-menu :default-active="path" class="el-menu-vertical-demo" @select="handleSelect"
        background-color="#1A1C1F" text-color="#fff" active-text-color="#F2303D" router>
        <div class="menu-logo">
          <img :src="require('@/assets/image/logo_menu.png')" alt="" class="logo">
        </div>
        <div class="user-info" v-show="$store.state.user.showUser">
          <img :src="require('@/assets/image/case_pic01.png')" alt="" class="user-pic">
          <span class="name">机智的弗洛里安兰斯伯爵</span>
          <span class="vip-tip">每天仅1元畅享全站影片</span>
          <div class="open-vip">立即开通</div>
        </div>
        <el-menu-item index="/home" v-show="!$store.state.user.showUser">
          <img v-if="path == '/home'" :src="require('@/assets/image/icon_shouye01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_shouye02.png')" alt="" class="icon-menu">
          <span>首页</span>
        </el-menu-item>
        <el-menu-item index="/history">
          <img v-if="path == '/history'" :src="require('@/assets/image/icon_history01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_history02.png')" alt="" class="icon-menu">
          <span>观看历史</span>
        </el-menu-item>
        <el-menu-item index="/collect">
          <img v-if="path == '/collect'" :src="require('@/assets/image/icon_shoucang01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_shoucang02.png')" alt="" class="icon-menu">
          <span>我的收藏</span>
        </el-menu-item>
        <div class="text-tip" v-show="!$store.state.user.showUser">特色频道</div>
        <el-menu-item index="/ancient" v-show="!$store.state.user.showUser">
          <img v-if="path == '/ancient'" :src="require('@/assets/image/icon_guzhuang01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_guzhuang02.png')" alt="" class="icon-menu">
          <span>古装</span>
        </el-menu-item>
        <el-menu-item index="/modern" v-show="!$store.state.user.showUser">
          <img v-if="path == '/modern'" :src="require('@/assets/image/icon_xiandai01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_xiandai02.png')" alt="" class="icon-menu">
          <span>现代</span>
        </el-menu-item>
        <el-menu-item index="/action" v-show="!$store.state.user.showUser">
          <img v-if="path == '/action'" :src="require('@/assets/image/icon_action01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_action02.png')" alt="" class="icon-menu">
          <span>动作</span>
        </el-menu-item>
        <el-menu-item index="/joker" v-show="!$store.state.user.showUser">
          <img v-if="path == '/joker'" :src="require('@/assets/image/icon_joke01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_joke02.png')" alt="" class="icon-menu">
          <span>搞笑</span>
        </el-menu-item>
        <el-menu-item index="/account" v-show="$store.state.user.showUser">
          <img v-if="path == '/account'" :src="require('@/assets/image/icon_setting01.png')" alt="" class="icon-menu">
          <img v-else :src="require('@/assets/image/icon_setting02.png')" alt="" class="icon-menu">
          <span>账号设置</span>
        </el-menu-item>
        <div class="text-tip" v-show="!$store.state.user.showUser">安全模式</div>
        <div class="module" v-show="!$store.state.user.showUser" @click="onActive(1)">
          <img v-if="active==1" :src="require('@/assets/image/icon_teenager02.png')" alt="" class="icon-tip">
          <img v-else :src="require('@/assets/image/icon_teenager01.png')" alt="" class="icon-tip">
          <span :style="{'color':active==1?'#F2303D':'#fff'}">青少年保护模式</span>
        </div>
        <div class="module" v-show="!$store.state.user.showUser" @click="onActive(2)">
          <img v-if="active==2" :src="require('@/assets/image/icon_dispute02.png')" alt="" class="icon-tip">
          <img v-else :src="require('@/assets/image/icon_dispute01.png')" alt="" class="icon-tip">
          <span :style="{'color':active==2?'#F2303D':'#fff'}">条款协议</span>
        </div>
      </el-menu>
      <div class="code-contain">
          <img :src="require('@/assets/image/codeQR_pic.png')" alt="" class="code-pic">
          <div class="code-tip">扫一扫  手机观看更方便</div>
        </div> 
    </el-aside> -->
    <el-container>
      <!-- <el-header>
         <aside-nav /> 
      </el-header> -->
      <el-main>
        <router-view></router-view>
      </el-main>
      <!-- <el-footer>
        <web-footer /> 
      </el-footer> -->
    </el-container>
    <!-- 青少年保护模式弹窗 -->
    <el-dialog
      width="416px"
      :visible="showTeen"
      append-to-body
      :show-close="false"
      center
      close-on-click-modal
      @close="onCancelTeen"
    >
      <div class="teen-container">
        <div class="teen-title">青少年保护模式</div>
        <div class="teen-tip">
          <img src="@/assets/image/teen_time.png" alt="" class="teen-icon" />
          <div class="text">
            <div class="text-item">防止沉迷&emsp;安全护航</div>
            <div class="text-item">
              默认每天最多使用40分钟、晚上22时-次日6时无法使用星娱短剧
            </div>
          </div>
        </div>
        <div class="teen-tip">
          <img src="@/assets/image/teen_aq.png" alt="" class="teen-icon" />
          <div class="text">
            <div class="text-item">账户安全&emsp;安心观看</div>
            <div class="text-item">无法进行充值、消费等操作</div>
          </div>
        </div>
        <div class="teen-tip">
          <img src="@/assets/image/teen_collect.png" alt="" class="teen-icon" />
          <div class="text">
            <div class="text-item">甄选内容&emsp;陪伴成长</div>
            <div class="text-item">
              在青少年模式中，我们精选一些适合青少年观看的内容
            </div>
          </div>
        </div>
        <div class="teen-tip">
          <img src="@/assets/image/teen_aq2.png" alt="" class="teen-icon" />
          <div class="text">
            <div class="text-item">信息安全&emsp;健康使用</div>
            <div class="text-item">
              严格保护青少年的个人信息安全，保障青少年健康使用
            </div>
          </div>
        </div>
        <div class="teen-btn" v-if="!isOpen" @click="onOpenTeen">
          开启青少年模式
        </div>
        <div class="teen-btn" v-else @click="onCloseTeen">关闭青少年模式</div>
        <div>
          <span class="before">更多信息可阅读</span
          ><span class="after" @click="toTeenAgree"
            >《儿童/青少年使用须知》</span
          >
        </div>
      </div>
    </el-dialog>
    <!-- 纠纷处置弹窗 -->
    <el-dialog
      width="416px"
      title="条款协议"
      :visible="showDispute"
      append-to-body
      center
      @close="onCancelDispute"
    >
      <el-form label-width="80px" :model="params" size="small">
        <el-form-item label="标题">
          <el-input v-model="params.name" placeholder="请输入标题"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input
            v-model="params.region"
            placeholder="请输入内容描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input
            v-model="params.type"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="问题截图">
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar" />
            <div v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div class="icon-text">上传图片</div>
            </div>
            <div class="img-tip">
              <span>请上传问题图片</span>
              <span>支持png、jpg、jpge图片格式，大小不要超过5M</span>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="btn-container">
        <div class="btn" @click="onsubmit">提交</div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
export default {
  data () {
    return {
      path: '',
      active: 0,
      showTeen: false,
      isOpen: false,
      showDispute: false,
      params: {},
      imageUrl: ''
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to, from) {
        console.log(to, 'to')
        this.active = 0
        this.path = to.path
        if (to.path == '/account') {
          this.$store.state.user.showUser = true
        } else {
          this.$store.state.user.showUser = false
        }
      }
    },
    path: {
      handler (newVal) {
        if (newVal) this.active = 0
      }
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      this.path = key
      console.log(key, keyPath)
    },
    onActive (num) {
      this.active = num
      this.path = ''
      if (num == 1) {
        this.showTeen = true
      }
      if (num == 2) {
        this.showDispute = true
      }
      console.log(this.showTeen)
    },
    toTeenAgree () {
      this.$router.push('/teenagerAgreement')
    },
    onOpenTeen () {
      this.active = 0
      this.path = this.$route.path
      this.showTeen = false
      this.isOpen = true
    },
    onCloseTeen () {
      this.active = 0
      this.path = this.$route.path
      this.showTeen = false
      this.isOpen = false
    },
    onCancelTeen () {
      this.active = 0
      this.path = this.$route.path
      this.showTeen = false
    },
    onsubmit () {
      this.showDispute = false
    },
    onCancelDispute () {
      this.showDispute = false
      this.active = 0
      this.path = this.$route.path
    }
  },
  mounted () {
    this.handleSelect()
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  width: 172px !important;
  height: 100vh;
  padding: 24px 10px;
  background-color: #1a1c1f;
  color: #fff;
  border-right: 1px solid #2e3033;
  .code-contain {
    width: 152px;
    height: 175px;
    background-color: #2e3033;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    left: 10px;
    bottom: 24px;
    .code-pic {
      width: 120px;
      height: 120px;
      margin-bottom: 10px;
    }
    .code-tip {
      color: #fff;
      opacity: 0.6;
      font-size: 12px;
      line-height: 15px;
    }
  }
}

.el-main {
  width: calc(100% - 172px);
  height: 100vh;
  padding: 0;
}
.el-menu-item {
  width: 154px;
  height: 60px;
  // padding-left: 0 !important;
  border-radius: 8px;
  padding-left: 16px !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .icon-menu {
    width: 18px;
    height: 18px;
    margin-right: 12px;
  }
  &:nth-child(4) {
    border-bottom: 1px solid #2e3033;
  }
}
.el-menu-item:hover {
  background-color: #2e3033 !important;
}
.el-menu {
  border: none;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .menu-logo {
    width: 154px;
    height: 24px;
    padding-left: 16px;
    margin-bottom: 18px;
    // padding: 0 16px;
    display: flex;
    justify-content: flex-start;
    .logo {
      width: 120px;
      height: 24px;
    }
  }
  .user-info {
    width: 154px;
    padding-left: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
    line-height: 16px;
    margin-bottom: 40px;
    .user-pic {
      width: 72px;
      height: 72px;
      border-radius: 50%;
      margin-bottom: 12px;
    }
    .name {
      color: #fff;
      opacity: 0.6;
      margin-bottom: 20px;
    }
    .vip-tip {
      color: #d3ad74;
      margin-bottom: 8px;
    }
    .open-vip {
      width: 120px;
      height: 36px;
      background: linear-gradient(to right, #f5d9ac, #d3ad74);
      border-radius: 8px;
      color: #603e11;
      font-size: 14px;
      text-align: center;
      line-height: 36px;
    }
  }
  .text-tip {
    width: 154px;
    padding-left: 16px;
    margin: 24px 0 12px 0;
    color: rgba(255, 255, 255, 0.6);
    font-size: 14px;
    line-height: 18px;
  }
  .module {
    width: 154px;
    padding-left: 16px;
    margin: 24px 0 12px 0;
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    .icon-tip {
      width: 16px;
      height: 16px;
      margin-right: 11px;
    }
  }
}
.el-dialog__wrapper {
  &::v-deep .el-dialog--center {
    background-color: #2e3033 !important;
  }
  // v-deep .el-dialog__title{
  //   background-color: #2E3033 !important;
  // }
  .teen-container {
    width: 100%;
    padding: 0 28px;
    color: #fff;
    .teen-title {
      text-align: center;
      line-height: 22px;
      font-size: 16px;
      margin-bottom: 27px;
    }
    .teen-tip {
      display: flex;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 30px;
      .teen-icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .text {
        display: flex;
        flex-direction: column;
        .text-item:last-child {
          font-size: 12px;
          margin-top: 8px;
        }
      }
    }
    .teen-btn {
      height: 40px;
      background: linear-gradient(to bottom, #ff0c1b, #ff474f);
      border-radius: 8px;
      color: #fff;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      cursor: pointer;
    }
    .before {
      color: #54585c;
      font-size: 14px;
    }
    .after {
      color: #ff474f;
      font-size: 14px;
      cursor: pointer;
    }
  }
  &::v-deep .el-dialog__title {
    color: #fff;
  }
  &::v-deep .el-form-item__label {
    color: #fff;
  }
  &::v-deep .el-input__inner {
    background-color: #404347 !important;
    border: none;
    color: #fff;
    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
  }
  &::v-deep .avatar-uploader {
    // display: flex;
    width: 104px;
    position: relative;
  }
  &::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #ff858d;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    // overflow: hidden;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #ff0c1b;
    width: 104px;
    height: 52px;
    line-height: 52px;
    text-align: center;
  }
  .avatar {
    width: 104px;
    height: 104px;
    display: block;
  }
  .icon-text {
    height: 52px;
  }
  .img-tip {
    width: 250px;
    height: 104px;
    padding-left: 20px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
    line-height: 22px;
    text-align: left;
    position: absolute;
    left: 104px;
    top: 0;
    z-index: 2024;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
  .btn-container {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 60px;
    .btn {
      width: 320px;
      height: 40px;
      background: linear-gradient(to bottom, #ff0c1b, #ff474f);
      border-radius: 8px;
      color: #fff;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}
</style>
